import { Group, Path, Segment } from "paper/dist/paper-core";
import { BORDER_COLOR, CANVAS_CENTER, FILL_COLOR } from "../../constants";

export default class Hair extends Group {
  static createRightHair() {
    const rightHair = new Path({
      segments: [
        [CANVAS_CENTER + 11, 18],
        new Segment({
          point: [CANVAS_CENTER + 12, 30],
          handleIn: [-2, -3],
          handleOut: [2, 4],
        }),
        [CANVAS_CENTER + 16, 36],
        new Segment({
          point: [CANVAS_CENTER + 19, 26],
          handleOut: [0, -3],
          handleIn: [2, 4],
        }),
      ],
      strokeColor: BORDER_COLOR,
      fillColor: FILL_COLOR,
      closed: true,
    });

    const rightHairHighlight = new Path({
      segments: [
        new Segment({
          point: [CANVAS_CENTER + 13, 21],
          handleOut: [6, 7],
        }),
        new Segment({
          point: [CANVAS_CENTER + 18, 30],
          handleOut: [2, -5],
        }),
      ],
      fillColor: "white",
      closed: true,
    });

    return new Group([rightHair, rightHairHighlight]);
  }

  static createLeftHair() {
    const leftHair = new Path({
      segments: [
        [CANVAS_CENTER - 11, 18],
        new Segment({
          point: [CANVAS_CENTER - 12, 30],
          handleIn: [2, -3],
          handleOut: [-3, 4],
        }),
        [CANVAS_CENTER - 16, 36],
        new Segment({
          point: [CANVAS_CENTER - 19, 24],
          handleOut: [2, -3],
          handleIn: [-3, 4],
        }),
      ],
      strokeColor: BORDER_COLOR,
      fillColor: FILL_COLOR,
      closed: true,
    });

    const leftHairHighlight = new Path({
      segments: [
        new Segment({
          point: [CANVAS_CENTER - 13, 21],
          handleOut: [-6, 5],
        }),
        new Segment({
          point: [CANVAS_CENTER - 18, 30],
          handleOut: [-3, -6],
        }),
      ],
      fillColor: "white",
      closed: true,
    });

    return new Group([leftHair, leftHairHighlight]);
  }

  static createCombover() {
    const combover = new Path({
      segments: [
        new Segment({
          point: [42, 10],
          handleOut: [5, 7],
          handleIn: [0, 0],
        }),
        new Segment({
          point: [63, 20],
          handleIn: [-2, -15],
          handleOut: [-5, 7],
        }),
        new Segment({
          point: [34, 14],
          handleIn: [2, 18],
        }),
        new Segment({
          point: [38, 16],
          handleIn: [-2, 0],
        }),
        new Segment({
          point: [39, 11],
          handleIn: [-2, 2],
        }),
        new Segment({
          point: [43, 13],
          handleIn: [-2, 1],
          handleOut: [-2, 1],
        }),
      ],
      strokeColor: BORDER_COLOR,
      fillColor: FILL_COLOR,
      closed: true,
      applyMatrix: false,
    });

    const comboverHighlight = new Path({
      segments: [
        new Segment({
          point: [41, 15],
          handleOut: [6, 3],
          handleIn: [6, 6],
        }),
        new Segment({
          point: [61, 19],
          handleIn: [-2, -11],
          handleOut: [-7, -9],
        }),
      ],
      fillColor: "white",
      closed: true,
    });

    return new Group([combover, comboverHighlight]);
  }

  constructor() {
    const left = Hair.createLeftHair();
    const right = Hair.createRightHair();
    const combover = Hair.createCombover();

    super({ children: [left, right, combover] });

    this.combover = combover;
    this.initialPositionY = this.combover.position.y;
    this.combover.position.y = this.initialPositionY + 1;
  }

  combover: paper.Group;
  initialPositionY: number;

  animateIn = () =>
    new Promise((resolve) => {
      return this.combover
        .tweenTo(
          { "position.y": this.initialPositionY - 1 },
          { duration: 300, easing: "easeInOutQuad" },
        )
        .then(() => {
          this.combover
            .tweenTo(
              { "position.y": this.initialPositionY + 2 },
              { duration: 150, easing: "easeInOutQuad" },
            )
            .then(resolve);
        });
    });
}
